import React, { useContext, useEffect, useState } from 'react'
import './Subscription.css'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { mapData, handleRedirectInternal } from '../../product/common/components'

import RegistrationLayout from '../../custom/components/templates/RegistrationLayout'
import SEO from '@/utils/SEO'
import RegisterComponent from '../../product/components/species/dynamic/common/Register/RegisterComponent'

import { makeStyles, useTheme } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Switch from '@material-ui/core/Switch'
import { Link } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import SecondaryButton from '../../product/components/atoms/SecondaryButton'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import AlertContext from '../../product/context/alert/alertContext'
// import SkyflowCardDetails from '../../product/components/organisms/SkyflowCardDetails/index'
// import SkyflowCardDetails from '../../custom/components/organisms/SkyflowCardDetails'
import BankDetails from '../../custom/components/organisms/BankDetails'
import { currencyFormat, capitalize, dateFormatFunction } from '../../custom/common/components'
import PayContext from '../../product/context/payment/payContext'
import CommonContext from '../../custom/context/common/commonContext'
import AuthContext from '../../product/context/auth/authContext'
import FullScreenPopup from '../../product/components/organisms/FullScreenPopup'
import StripeCardContext from '../../product/context/stripe/card/cardContext'
import StripeBankContext from '../../product/context/stripe/bank/bankContext'
import StripeCustomerContext from '../../product/context/stripe/customer/customerContext'
import MyPaymentComponent from '@/custom/components/species/checkout/MyPaymentComponent'

import MembershipContext from '../../product/context/membership/membershipContext'

import UserContext from '../../product/context/user/userContext'
import { Button, IconButton, ListItem } from '@material-ui/core'
import SettingContext from '@/product/context/seller/setting/settingContext'

const creditCardYearOptions = []
let date = new Date()
let currentYear = date.getFullYear()
let upToYear = parseInt(currentYear) + 25
for (let year = parseInt(currentYear); year < parseInt(upToYear); year++) {
    creditCardYearOptions.push({
        value: year,
        show: year,
    })
}
const creditCardMonthOptions = []
for (let month = parseInt(1); month <= parseInt(12); month++) {
    let monthValue = ('0' + month).slice(-2)
    creditCardMonthOptions.push({
        value: monthValue,
        show: monthValue,
    })
}
const useStyles = makeStyles((theme) => ({
    buttonProgress: {
        color: 'red',
        position: 'absolute',
        left: '50%',
        marginTop: -50,
        marginLeft: -12,
    },
}))

export default function Membership(props) {
    const [activeStep, setActiveStep] = useState(0)
    const [reload, setReload] = useState(true)
    const {
        searchTableAction,
        searchTable,
        table_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseSetting,
    } = useContext(SettingContext)
    const handleNext = (type, plan) => {
        if (type === 'timebidder') {
            setRegType(0)
            setCustomInitialBuyer({
                ...customInitialBuyer,
                reference_plan: plan,
            })
        } else {
            setRegType(1)
            setCustomInitialSeller({
                ...customInitialSeller,
                reference_plan: plan,
            })
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        const type = queryParams.get('type')
        const plan = queryParams.get('plan')
        if (type && plan) handleNext(type, plan)
        else setActiveStep(0)
    }, [reload])

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
    }

    const classes = useStyles()
    const history = useHistory()
    const { setAlert } = useContext(AlertContext)
    const payContext = useContext(PayContext)
    const membershipContext = useContext(MembershipContext)

    const authContext = useContext(AuthContext)
    const { loadUser, user, isAuthenticated } = authContext
    const userContext = useContext(UserContext)
    const {
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
        updateProfile,
    } = userContext
    const {
        payCartStripe,
        responseStatus: responseStatusPayment,
        clearResponse: clearResponsePayment,
    } = payContext

    const { freeTrialActivation, responseStatus: responseStatusMembership } = membershipContext

    const { allBiddingPlan, membership, setCurrentMembership } = useContext(CommonContext)
    const {
        get_all_card_details,
        getAllStripeCards,
        responseStatus: responseStatusCard,
        clearResponse: clearResponseCard,
    } = useContext(StripeCardContext)
    // const { cashFreeMembershipPayment } = useContext(PayContext)
    const [cards, setCards] = useState([])
    const [banks, setBanks] = useState([])
    const [bidPlan, setBidPlan] = useState([])
    const [selectedCard, setSelectedCard] = useState(false)
    const [paymentProcess, setPaymentProcess] = useState(true)

    // const {
    //     skyflow_cards,
    //     getSkyflowCredit,
    //     responseStatus: responseStatusCard,
    //     clearResponse: clearResponseCard,
    // } = useContext(UserContext)

    const {
        get_all_bank_details,
        getAllStripeBanks,
        responseStatus: responseStatusBank,
    } = useContext(StripeBankContext)

    const {
        customer_details,
        createStripeCustomer,
        getStripeCustomer,
        responseStatus: customerResponseStatus,
    } = useContext(StripeCustomerContext)

    const [manageCard, setManageCard] = useState({
        popup: false,
        status: 'new',
        data: null,
    })

    const toggleFullScreenCardPopup = (popup, status, data) => {
        setManageCard({ popup, status, data })
    }

    const [manageBank, setManageBank] = useState({
        popup: false,
        status: 'new',
        data: null,
    })

    const toggleFullScreenBankPopup = (popup, status, data) => {
        setManageBank({ popup, status, data })
    }

    const [paymentLoading, setPaymentLoading] = useState(false)
    const [subPayPopup, setSubPayPopup] = useState(false)
    const [freeTrialPopup, setFreeTrialPopup] = useState(false)
    const [bidingPlan, setBiddingPlan] = useState(allBiddingPlan)
    const [membershipPlan, setMembershipPlan] = useState('')

    const validationFreeTrial = Yup.object({
        planName: Yup.string().required('Required!'),
    })

    const validationPayment = Yup.object({
        payment_method: Yup.string().required('Required!'),
        planName: Yup.string().required('Required!'),
        period: Yup.string().required('Required!'),
    })

    const freeTrialFormik = useFormik({
        initialValues: {
            planName: '',
            period: 'free',
        },
        validateOnBlur: false,
        validationSchema: validationFreeTrial,
        onSubmit: (values) => {
            // setLoading(true)
            freeTrialFormik.setSubmitting(true)
            freeTrialActivation(values)
        },
    })

    const cardFormik = useFormik({
        initialValues: {
            cards: '',
            payment_method: 'card',
            no_of_cards: 'existing',
            pay_type: 'membership_payment',
            amount: 0,
            planName: '',
            period: 'yearly',
        },
        validateOnBlur: false,
        validationSchema: validationPayment,
        onSubmit: (values) => {
            // setLoading(true)
            if (paymentProcess) {
                cardFormik.setSubmitting(true)
                let formData = {
                    payment_object: {
                        planName: values.planName,
                    },
                    period: values.period,
                    paymentInfo: {
                        source: selectedCard.id,
                        customer: user.stripe_id,
                        account_id: process.env.REACT_APP_STRIPE_ACCOUNT,
                    },
                    payment_method: 'online',
                    currency: 'EUR',
                    payment_type: selectedCard.last4 ? 'card' : 'bank',
                    pay_type: values?.pay_type,
                    amount: 1,
                    email_tigger: true,
                    customCartFields: props.customCartFields || null,
                    admin_fee: props.transactionFee ? cartValues.processing_fees : null,
                    admin_fee_percent: props.transactionFee ? cartValues.processing_percent : null,
                    project: 'timetogive-network',
                    additional_buynow_data: { shipping_service_type: '' },
                    // idempotencyCheck: true,
                    otpRequired: true,
                }
                console.log(formData, 'formData')
                if (selectedCard.id) {
                    payCartStripe(formData)
                    localStorage.setItem('plandata', JSON.stringify(formData))
                    setPaymentProcess(false)
                } else {
                    setAlert('Please select/add a card to proceed', 'error')
                    setPaymentProcess(true)
                }
            }
        },
    })

    const selectFreeTrialPlan = (data) => {
        if (data) {
            setFreeTrialPopup(true)
            freeTrialFormik.setFieldValue('planName', data.type)
        }
    }

    const selectSubscriptionPlan = (data) => {
        if (isAuthenticated) {
            if (user) {
                if (data) {
                    setSubPayPopup(true)

                    cardFormik.setFieldValue('planName', data.type)
                    if (data.type === 'timeBidderPlan') {
                        cardFormik.setFieldValue('period', 'monthly')
                        cardFormik.setFieldValue('amt', data.monthly_deposit_amount)
                    } else if (data.type === 'timeBidder') {
                        cardFormik.setFieldValue('period', 'yearly')
                        cardFormik.setFieldValue('amt', data.yearly_deposit_amount)
                    } else {
                        cardFormik.setFieldValue('period', 'five_yearly')
                        cardFormik.setFieldValue('amt', data.five_yearly_deposit_amount)
                    }
                }
            }
        } else {
            handleRedirectInternal(history, `registration?type=${data.user_type}&plan=${data.type}`)
        }
    }

    useEffect(() => {
        if (props.from === 'bidding') {
            localStorage.setItem(
                'redirect',
                window.location.href.slice(window.location.origin.length + 1),
            )
        }
    }, [props])
    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1)
    }

    const handleChange = (event) => {
        if (event.target.checked) {
            cardFormik.setFieldValue('period', 'yearly')
        } else {
            cardFormik.setFieldValue('period', 'monthly')
        }
    }
    useEffect(() => {
        if (user?.membership) {
            setBiddingPlan([allBiddingPlan[0], allBiddingPlan[1], allBiddingPlan[2]])
        } else {
            setBiddingPlan(allBiddingPlan)
        }
    }, [allBiddingPlan])

    useEffect(() => {
        if (user?.membership) {
            if (user.membership_period === 'monthly') {
                setMembershipPlan('timeBidderPlan')
            } else if (user.membership_period === 'yearly') {
                setMembershipPlan('timeBidder')
            } else if (user.membership_period === 'five_yearly') {
                setMembershipPlan('timeBidder \r\n offer')
            }
        }
    }, [user])

    useEffect(() => {
        if (isAuthenticated) {
            if (user) {
                if (user.membership) {
                    if (allBiddingPlan && allBiddingPlan.length) {
                        let activePlan = allBiddingPlan.filter(
                            (value) => value.type === membershipPlan,
                        )
                        if (activePlan.length) {
                            setCurrentMembership(activePlan[0])
                        } else {
                            setCurrentMembership('')
                        }
                    }
                }
                let filteredList = []
                if (!user.both_access) {
                    filteredList = allBiddingPlan.filter((e) => e.type == user.reference_plan)
                } else {
                    filteredList = allBiddingPlan
                }
                setBidPlan(filteredList)
            }
        } else {
            if (allBiddingPlan && allBiddingPlan.length) {
                setBidPlan(allBiddingPlan)
                setCurrentMembership('')
            }
        }
    }, [isAuthenticated, user, allBiddingPlan, membershipPlan])

    useEffect(() => {
        let values = {
            page: 1,
            limit: 20,
            count: 1,
            order: '',
            orderby: '',
            table: 'user_memberships',
            filters: {
                fields: {
                    value: user?.id ? user.id : null,
                    type: 'in',
                    field: 'usm.user_id',
                },
            },
            tableJoins: [
                {
                    baseTable: 'users',
                    // customTable: 'users',
                    joinType: 'inner',
                    baseJoinField: 'id',
                    connectJoinField: 'user_id',
                },
                {
                    baseTable: 'bidding_plan',
                    // customTable: 'users',
                    joinType: 'inner',
                    baseJoinField: 'type',
                    connectJoinField: 'membership',
                },
            ],
        }
        searchTable(values)
    }, [])

    console.log('user', user, user?.stripe_id, !user?.stripe_id)

    const getStripeBanks = () => {
        getAllStripeBanks({
            account_id: process.env.REACT_APP_STRIPE_ACCOUNT,
            customer_id: user ? user.stripe_id : '',
            object: 'bank_account',
        })
        toggleFullScreenBankPopup(false, 'new', null)
    }

    useEffect(() => {
        if (isAuthenticated) {
            if (user) {
                if (user.id) {
                    if (user.stripe_id) {
                        getAllStripeCards({
                            account_id: process.env.REACT_APP_STRIPE_ACCOUNT,
                            customer_id: user.stripe_id,
                            object: 'card',
                        })
                        getStripeBanks()
                    } else {
                        createStripeCustomer(
                            {
                                account_id: process.env.REACT_APP_STRIPE_ACCOUNT,
                                description: 'TEST CUSTOMER',
                                email: user.email,
                                name: user.first_name + ' ' + user.last_name,
                            },
                            true,
                        )
                    }
                }
            }
        }
    }, [user, isAuthenticated])

    useEffect(() => {
        if (user && user.membership_period === 'yearly') {
            cardFormik.setFieldValue('period', 'yearly')
        }
    }, [user, membership])

    useEffect(() => {
        if (get_all_card_details && get_all_card_details.records?.length) {
            setCards(get_all_card_details.records)
        }
        return () => {
            setCards([])
        }
    }, [get_all_card_details])

    useEffect(() => {
        if (get_all_bank_details && get_all_bank_details.records.length) {
            setBanks(get_all_bank_details.records.filter((inner) => inner.status !== 'new'))
        }
        return () => {
            setBanks([])
        }
    }, [get_all_bank_details])

    const handleSelect = (object) => {
        setSelectedCard(object)
        if (object.card_last4) {
            cardFormik.setFieldValue('payment_method', 'card')
            cardFormik.setFieldValue('cards', object.id)
        } else {
            cardFormik.setFieldValue('payment_method', 'bank')
            cardFormik.setFieldValue('cards', object.id)
        }
    }

    const submitButton = (type, data) => {
        if (type === 'active') {
            return <PrimaryButton label="Active Plan" disabled />
        } else if (type === 'freetrial') {
            if (cards.length) {
                return (
                    <SecondaryButton
                        btnSize="small"
                        label="Free trial"
                        onClick={() => selectFreeTrialPlan(data)}
                    />
                )
            } else {
                return (
                    <SecondaryButton
                        btnSize="small"
                        label="Free trial"
                        onClick={() => {
                            toggleFullScreenCardPopup(true, 'new', null)
                            setAlert('Need to add card for activating the free trial', 'error')
                        }}
                    />
                )
            }
        } else if (type === 'upgrade') {
            return <PrimaryButton label="Upgrade" onClick={() => selectSubscriptionPlan(data)} />
        } else if (type === 'started') {
            return (
                <PrimaryButton label="Get Started" onClick={() => selectSubscriptionPlan(data)} />
            )
        } else if (type === 'active_started') {
            return (
                <PrimaryButton label="Trial Active" onClick={() => selectSubscriptionPlan(data)} />
            )
        } else if (type === 'contact') {
            return (
                <PrimaryButton
                    label="Contact Us"
                    onClick={() => handleRedirectInternal(history, 'contactus')}
                />
            )
        }
    }

    const redirectFunction = (data) => {
        console.log(data, 'data after redirect')
        if (data?.status && data.status === 'success') {
            if (data?.data?.pay_type == 'membership_payment') {
                console.log('entered==', user?.seniority)
                if (!user?.seniority || user?.seniority == null) {
                    loadUser()
                    handleRedirectInternal(history, 'account/profile')

                    console.log('rrrrrrr', user?.seniority)
                } else {
                    loadUser()
                    handleRedirectInternal(history, 'payments/subscription')
                }
            } else {
                handleRedirectInternal(history, 'invoices/all')
            }
        } else if (data?.status == 'error') {
            loadUser()
            handleRedirectInternal(history, 'subscription')
        } else if (data?.data?.pay_type == 'membership_payment') {
            if (!user?.seniority || user?.seniority == null) {
                loadUser()
                handleRedirectInternal(history, 'account/profile')
            } else {
                loadUser()
                handleRedirectInternal(history, 'subscription')
            }
        } else {
            const redirectPage = data.data.to === 'buynow' ? 'invoices/all' : 'singlecart'
            handleRedirectInternal(history, redirectPage)
        }
    }

    useEffect(() => {
        if (responseStatusPayment) {
            setPaymentProcess(true)
            console.log('responseStatusPayment.from', responseStatusPayment.from)
            if (responseStatusPayment.from === 'payment_response') {
                console.log(responseStatusPayment, 'responseStatusPayment')
                redirectFunction(responseStatusPayment)
                clearResponsePayment()
            }
            if (responseStatusPayment.from === 'payment') {
                if (responseStatusPayment.status === 'success') {
                    setSubPayPopup(false)
                    console.log('responseStatusPayment', responseStatusPayment)
                    if (responseStatusPayment.type === 6) {
                        window.location.replace(responseStatusPayment.data)
                    }
                    if (user?.admin) {
                        updateProfile(
                            {
                                membership_autopay: 1,
                                email: user?.email,
                                id: user?.id,
                                last_name: user?.last_name,
                                first_name: user?.first_name,
                                phone: user?.phone,
                                address1: user?.address,
                                city: user?.city,
                                state: user?.state,
                                zip: user?.zip,
                                both_access: 1,
                                emp_type: 'seller',
                            },
                            // false,
                            // 'requestUpdate',
                        )
                    }

                    // handleRedirectInternal(history, 'search')
                    loadUser()
                    console.log('cominghhh')
                }
                clearResponsePayment()
            }
            // setIsLoading(false)
        }
    }, [responseStatusPayment])

    useEffect(() => {
        if (responseStatusMembership) {
            if (responseStatusMembership.from === 'freeTrialActivation') {
                if (responseStatusMembership.status === 'success') {
                    if (user?.admin) {
                        updateProfile(
                            {
                                membership_autopay: 1,
                                email: user?.email,
                                id: user?.id,
                                last_name: user?.last_name,
                                first_name: user?.first_name,
                                phone: user?.phone,
                                address1: user?.address,
                                city: user?.city,
                                state: user?.state,
                                emp_type: 'seller',
                                zip: user?.zip,
                                both_access: 1,
                            },
                            'cancelMemberhip',
                        )
                    } else {
                        updateProfile(
                            {
                                membership_autopay: 1,
                            },
                            'cancelMemberhip',
                        )
                    }

                    setFreeTrialPopup(false)
                    loadUser()
                    // handleRedirectInternal(history, 'search')
                }
            }
        }
    }, [responseStatusMembership])

    useEffect(() => {
        if (responseStatusCard) {
            if (
                responseStatusCard.from === 'skyflow_add' ||
                responseStatusCard.from === 'skyflow_update' ||
                responseStatusCard.from === 'skyflow_delete'
            ) {
                if (responseStatusCard.status === 'success') {
                    getAllStripeCards({
                        account_id: process.env.REACT_APP_STRIPE_ACCOUNT,
                        customer_id: user ? user.stripe_id : '',
                        object: 'card',
                    })
                }
            }
            // setIsLoading(false)
        }
    }, [responseStatusCard])

    useEffect(() => {
        if (responseStatusBank) {
            if (
                responseStatusBank.from === 'bank_source_create' ||
                responseStatusBank.from === 'bank_source_update' ||
                responseStatusBank.from === 'bank_source_delete'
            ) {
                if (responseStatusBank.status === 'success') {
                    getStripeBanks()
                }
            }
            // setIsLoading(false)
        }
    }, [responseStatusBank])

    return (
        <>
            <SEO title="Register" url={window.location.href} />
            {activeStep == 0 ? (
                <div>
                    <div className="subscriptionCnt">
                        <h1 className="subscriptionTitle">Subscription Plans</h1>
                        <div className="subscriptionInner">
                            {allBiddingPlan &&
                                bidingPlan?.map((data, index) => {
                                    // eslint-disable-next-line react/jsx-key

                                    return data?.user_type == 'timegiver' ? null : (
                                        <div
                                            className={
                                                data?.user_type == 'timebidder'
                                                    ? 'tbSubscription'
                                                    : 'tgSubscription'
                                            }
                                        >
                                            <div
                                                className={
                                                    data?.user_type == 'timebidder'
                                                        ? 'tbsTop'
                                                        : 'tgsTop'
                                                }
                                            >
                                                {user?.membership_period == 'free' &&
                                                    data.type == 'timeBidderPlan' && (
                                                        <p
                                                            className={
                                                                data.user_type == 'timebidder'
                                                                    ? 'activeTbTag'
                                                                    : 'activeTgTag'
                                                            }
                                                        >
                                                            Active
                                                        </p>
                                                    )}
                                                {user?.membership_period == 'yearly' &&
                                                    data.type == 'timeBidder' && (
                                                        <p
                                                            className={
                                                                data.user_type == 'timebidder'
                                                                    ? 'activeTbTag'
                                                                    : 'activeTgTag'
                                                            }
                                                        >
                                                            Active
                                                        </p>
                                                    )}
                                                {user?.membership_period == 'monthly' &&
                                                    data.type == 'timeBidderPlan' && (
                                                        <p
                                                            className={
                                                                data.user_type == 'timebidder'
                                                                    ? 'activeTbTag'
                                                                    : 'activeTgTag'
                                                            }
                                                        >
                                                            Active
                                                        </p>
                                                    )}
                                                {user?.membership_period == 'five_yearly' &&
                                                    data.type == 'timeBidder \r\n offer' && (
                                                        <p
                                                            className={
                                                                data.user_type == 'timebidder'
                                                                    ? 'activeTbTag'
                                                                    : 'activeTgTag'
                                                            }
                                                        >
                                                            Active
                                                        </p>
                                                    )}

                                                <h2>
                                                    {data.type == 'timeBidderPlan'
                                                        ? 'TimeBidder – Monthly Membership'
                                                        : data.plan_name == 'TimeBidder'
                                                        ? 'TimeBidder Yearly Membership'
                                                        : data.plan_name ==
                                                          '*Subscribe for 5 years and Save*'
                                                        ? '“5 for 5” – Limited Offer Five-Year Membership'
                                                        : 'TimeGiver Plan'}
                                                </h2>
                                            </div>

                                            <div
                                                className={
                                                    data.user_type == 'timebidder'
                                                        ? 'tbsMid'
                                                        : 'tgsMid'
                                                }
                                            >
                                                {data.type == 'timeBidderPlan' ? (
                                                    <>
                                                        <p>
                                                            Gain the access you want - view
                                                            available TimeGivers and secure a
                                                            meeting in return for a charitable
                                                            donation.
                                                        </p>
                                                        <p>
                                                            <b>£15 per user</b> for a monthly
                                                            membership which entitles you to
                                                            participate in as many Offers as you
                                                            would like.
                                                        </p>
                                                        {/* <p>
                                                            Enjoy the first month of this plan for
                                                            free, with no payment required. From the
                                                            second month, your credit card will be
                                                            auto-debited unless you choose to cancel
                                                            or upgrade.
                                                        </p> */}
                                                    </>
                                                ) : data.plan_name == 'TimeBidder' ? (
                                                    <>
                                                        <p>
                                                            Gain the access you want - view
                                                            available TimeGivers and secure a
                                                            meeting in return for a charitable
                                                            donation.
                                                        </p>
                                                        <p>
                                                            <b> £150 per user</b> for a yearly
                                                            membership which entitles you to
                                                            participate in as many offers as you
                                                            would like.
                                                        </p>
                                                        <p>
                                                            Additionally, Time to Give Network
                                                            includes a service solution that
                                                            actively pursues specific TimeGivers you
                                                            would like to see on the platform in
                                                            order to ensure a target-rich
                                                            environment.
                                                        </p>
                                                    </>
                                                ) : data.plan_name ==
                                                  '*Subscribe for 5 years and Save*' ? (
                                                    <>
                                                        <p>
                                                            Gain the access you want - view
                                                            available TimeGivers and secure a
                                                            meeting in return for a charitable
                                                            donation.
                                                        </p>
                                                        <p>
                                                            <b> £500 per user</b> includes all of
                                                            the benefits of Yearly Membership, at a
                                                            reduced annual rate.
                                                        </p>
                                                        <p>
                                                            Additionally, Time to Give Network is
                                                            happy to issue social media posts,
                                                            conveying how much we appreciate your
                                                            firm’s participation and provide a
                                                            <b className="ml-1">C</b>orporate{' '}
                                                            <b className="">S</b>ocial
                                                            <b className="ml-1">R</b>esponsibility
                                                            boost.
                                                        </p>
                                                        {/* <p>
                                                        Get a joint post on LinkedIn with TGN
                                                        thanking you for your support.
                                                    </p> */}
                                                    </>
                                                ) : (
                                                    <>
                                                        <p>
                                                            Support your favorite causes. Make your
                                                            time available to eligible TimeBidders
                                                            in return for significant donations to
                                                            your favorite charities.
                                                        </p>
                                                        <p>
                                                            Becoming a TimeGiver is free of charge.
                                                            A one-year membership allows you to make
                                                            unlimited Offers.
                                                        </p>
                                                    </>
                                                )}

                                                <h3></h3>
                                            </div>
                                            <div
                                                className={
                                                    data.user_type == 'timebidder'
                                                        ? 'tbsBottom'
                                                        : 'tgsBottom'
                                                }
                                            >
                                                {membership ? (
                                                    <>
                                                        {membership.type != data.type ? (
                                                            <>{submitButton('upgrade', data)}</>
                                                        ) : null}
                                                        {/* {user.membership_period === 'monthly' ? (
                                                        <>
                                                            {cardFormik.values.period ===
                                                            'monthly' ? (
                                                                <>
                                                                    {membership.type ===
                                                                    'bronze' ? (
                                                                        <>
                                                                            {data.type ===
                                                                            'bronze' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'active',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'silver' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'upgrade',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'gold' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'upgrade',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'enterprise' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'contact',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : null}
                                                                        </>
                                                                    ) : membership.type ===
                                                                      'silver' ? (
                                                                        <>
                                                                            {data.type ===
                                                                            'bronze' ? (
                                                                                <></>
                                                                            ) : data.type ===
                                                                              'silver' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'active',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'gold' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'upgrade',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'enterprise' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'contact',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : null}
                                                                        </>
                                                                    ) : membership.type ===
                                                                      'gold' ? (
                                                                        <>
                                                                            {data.type ===
                                                                            'bronze' ? (
                                                                                <></>
                                                                            ) : data.type ===
                                                                              'silver' ? (
                                                                                <></>
                                                                            ) : data.type ===
                                                                              'gold' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'active',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'enterprise' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'contact',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : null}
                                                                        </>
                                                                    ) : membership.type ===
                                                                      'enterprise' ? (
                                                                        <>
                                                                            {data.type ===
                                                                            'bronze' ? (
                                                                                <></>
                                                                            ) : data.type ===
                                                                              'silver' ? (
                                                                                <></>
                                                                            ) : data.type ===
                                                                              'gold' ? (
                                                                                <></>
                                                                            ) : data.type ===
                                                                              'enterprise' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'active',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : null}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {submitButton(
                                                                                'started',
                                                                                data,
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </>
                                                            ) : cardFormik.values.period ===
                                                              'yearly' ? (
                                                                <>
                                                                    {' '}
                                                                    {membership.type ===
                                                                    'bronze' ? (
                                                                        <>
                                                                            {data.type ===
                                                                            'bronze' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'started',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'silver' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'started',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'gold' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'started',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'enterprise' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'contact',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : null}
                                                                        </>
                                                                    ) : membership.type ===
                                                                      'silver' ? (
                                                                        <>
                                                                            {data.type ===
                                                                            'bronze' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'started',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'silver' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'started',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'gold' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'started',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'enterprise' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'contact',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : null}
                                                                        </>
                                                                    ) : membership.type ===
                                                                      'gold' ? (
                                                                        <>
                                                                            {data.type ===
                                                                            'bronze' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'started',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'silver' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'started',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'gold' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'started',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'enterprise' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'contact',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : null}
                                                                        </>
                                                                    ) : membership.type ===
                                                                      'enterprise' ? (
                                                                        <>
                                                                            {data.type ===
                                                                            'bronze' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'started',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'silver' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'started',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'gold' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'started',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'enterprise' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'contact',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : null}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {submitButton(
                                                                                'started',
                                                                                data,
                                                                            )}
                                                                        </>
                                                                    )}{' '}
                                                                </>
                                                            ) : null}
                                                        </>
                                                    ) : user.membership_period === 'yearly' ? (
                                                        <>
                                                            {cardFormik.values.period ===
                                                                'yearly' &&
                                                            !user.membership_date ? (
                                                                <>
                                                                    {membership.type ===
                                                                    'bronze' ? (
                                                                        <>
                                                                            {data.type ===
                                                                            'bronze' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'active',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'silver' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'upgrade',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'gold' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'upgrade',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'enterprise' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'contact',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : null}
                                                                        </>
                                                                    ) : membership.type ===
                                                                      'silver' ? (
                                                                        <>
                                                                            {data.type ===
                                                                            'bronze' ? (
                                                                                <></>
                                                                            ) : data.type ===
                                                                              'silver' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'active',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'gold' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'upgrade',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'enterprise' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'contact',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : null}
                                                                        </>
                                                                    ) : membership.type ===
                                                                      'gold' ? (
                                                                        <>
                                                                            {data.type ===
                                                                            'bronze' ? (
                                                                                <></>
                                                                            ) : data.type ===
                                                                              'silver' ? (
                                                                                <></>
                                                                            ) : data.type ===
                                                                              'gold' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'active',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : data.type ===
                                                                              'enterprise' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'contact',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : null}
                                                                        </>
                                                                    ) : membership.type ===
                                                                      'enterprise' ? (
                                                                        <>
                                                                            {data.type ===
                                                                            'bronze' ? (
                                                                                <></>
                                                                            ) : data.type ===
                                                                              'silver' ? (
                                                                                <></>
                                                                            ) : data.type ===
                                                                              'gold' ? (
                                                                                <></>
                                                                            ) : data.type ===
                                                                              'enterprise' ? (
                                                                                <>
                                                                                    {submitButton(
                                                                                        'active',
                                                                                        data,
                                                                                    )}
                                                                                </>
                                                                            ) : null}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {submitButton(
                                                                                'started',
                                                                                data,
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </>
                                                            ) : cardFormik.values.period ===
                                                              'monthly' ? (
                                                                <> </>
                                                            ) : null}
                                                        </>
                                                    ) : user.membership_period === 'free' ? (
                                                        <>
                                                            {cardFormik.values.period ===
                                                            'yearly' ? (
                                                                <>
                                                                    {membership.type ===
                                                                    data.type ? (
                                                                        <>
                                                                            {submitButton(
                                                                                'active_started',
                                                                                data,
                                                                            )}
                                                                        </>
                                                                    ) : data.type ===
                                                                      'enterprise' ? (
                                                                        <>
                                                                            {submitButton(
                                                                                'contact',
                                                                                data,
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {submitButton(
                                                                                'started',
                                                                                data,
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </>
                                                            ) : cardFormik.values.period ===
                                                              'monthly' ? (
                                                                <>
                                                                    {membership.type ===
                                                                    data.type ? (
                                                                        <>
                                                                            {submitButton(
                                                                                'active_started',
                                                                                data,
                                                                            )}
                                                                        </>
                                                                    ) : data.type ===
                                                                      'enterprise' ? (
                                                                        <>
                                                                            {submitButton(
                                                                                'contact',
                                                                                data,
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {submitButton(
                                                                                'started',
                                                                                data,
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </>
                                                            ) : null}
                                                        </>
                                                    ) : null} */}
                                                    </>
                                                ) : table_data?.records.length > 0 ? (
                                                    <>{submitButton('upgrade', data)}</>
                                                ) : (
                                                    <>
                                                        {submitButton('started', data)}
                                                        {/* {table_data?.records.length <= 0
                                                            ? data.type == membership?.type
                                                                ? submitButton('started', data)
                                                                : data.type == 'timeBidderPlan'
                                                                ? submitButton('freetrial', data)
                                                                : submitButton('started', data)
                                                            : null} */}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )
                                })}
                        </div>
                    </div>
                </div>
            ) : (
                <RegistrationLayout>
                    <div className="regLft">
                        <div className="text-center regInfo">
                            <h2> A {regType === 0 ? 'TIMEBIDDER' : 'TIMEGIVER'}</h2>
                            <h4>We&apos;re happy you&apos;re here!</h4>
                        </div>
                        <div className="regContainer">
                            <div className="regLt">
                                {regType === 0 ? (
                                    <>
                                        <RegisterComponent
                                            fieldValue={fieldValue}
                                            customInitial={customInitialBuyer}
                                            customValidation={customValidation}
                                            additionalFieldUpdate={additionalFieldUpdate}
                                            SubmitBtnLable={SubmitBtnLable}
                                            phoneVerify={true}
                                            emailVerify={true}
                                            autoRegisterAfterVerify={true}
                                            selectVerificationType={true}
                                            populateValidation={true}
                                            toggleOrganization={true}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <RegisterComponent
                                            fieldValue={sellerValue}
                                            customInitial={customInitialSeller}
                                            customValidation={customValidation}
                                            additionalFieldUpdate={additionalFieldUpdate}
                                            SubmitBtnLable={SubmitBtnLable}
                                            phoneVerify={true}
                                            emailVerify={true}
                                            autoRegisterAfterVerify={true}
                                            selectVerificationType={true}
                                            populateValidation={true}
                                            toggleOrganization={true}
                                        />
                                    </>
                                )}
                                <Button onClick={handleBack}>Back</Button>
                            </div>
                        </div>
                    </div>
                    <div className="regRgt">
                        <h3>ALREADY HAVE AN ACCOUNT?</h3>
                        <p>Sign in to your Account</p>
                        <Button onClick={() => handleRedirectInternal(history, 'login')}>
                            Sign In
                        </Button>
                    </div>
                </RegistrationLayout>
            )}

            <FullScreenPopup
                className={'adTempltPopup subPayPopup'}
                modaltitle={'Free Trial Confirmation'}
                open={freeTrialPopup}
                handleClose={() => setFreeTrialPopup(false)}
            >
                <div className="addUserModal mt-4">
                    {freeTrialFormik.values.planName ? (
                        <div className={`orderReviewBox ${freeTrialFormik.values.planName}`}>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="lftRvwBox">
                                    <h5>Plan Review</h5>
                                    <ul className="orderListli">
                                        <li>
                                            <span className="planNameWrp">
                                                <b>
                                                    {`${capitalizeFirstLetter(
                                                        freeTrialFormik.values.planName,
                                                    )}- Free Trial`}
                                                </b>
                                            </span>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>
                                            Gain the access you want - view available offers from
                                            TimeGivers and make donations to charities in return for
                                            their time. £15 per person for a one-month membership,
                                            which entitles you to participate in as many offers as
                                            you would like. You can avail of this plan without
                                            making a payment for the first month. From the start of
                                            the second month onwards, you will be auto-debited from
                                            your credit card for this plan. If you wish, you can
                                            cancel this plan or upgrade to the next plan.
                                        </li>
                                    </ul>
                                </div>
                                {/* <div className="rtImg">
                                    <img src="/assets/images/crown.png" />
                                </div> */}
                            </div>
                        </div>
                    ) : null}
                    {freeTrialFormik.values.planName ? (
                        <div className="d-flex justify-content-center align-item-center">
                            <div className="mt-4 col-sm-12 col-0 col-lg-3">
                                <PrimaryButton
                                    onClick={() => freeTrialFormik.handleSubmit()}
                                    label="Submit"
                                    type="submit"
                                    disabled={paymentLoading}
                                />
                            </div>
                        </div>
                    ) : null}
                </div>
            </FullScreenPopup>

            <FullScreenPopup
                className={'adTempltPopup subPayPopup'}
                modaltitle={'Subscription Payment'}
                open={subPayPopup}
                handleClose={() => setSubPayPopup(false)}
            >
                <div className="customContainer">
                    <div className="addUserModal mt-4">
                        {cardFormik.values.planName ? (
                            <div className={`orderReviewBox ${cardFormik.values.planName}`}>
                                <div className="d-flex align-items-center justify-content-between subCstmWrpCls">
                                    <div className="lftRvwBox">
                                        <h5>Plan Review</h5>
                                        <ul className="orderListli">
                                            {membership ? (
                                                <>
                                                    <li>
                                                        <span className="mr-2">
                                                            <b>
                                                                Existing Plan :{' '}
                                                                {user.membership_period ===
                                                                'monthly'
                                                                    ? 'TimeBidder Plan - '
                                                                    : user.membership_period ===
                                                                      'yearly'
                                                                    ? 'TimeBidder Plan - '
                                                                    : user.membership_period ===
                                                                      'free'
                                                                    ? 'Free Trial - '
                                                                    : user.membership_period ===
                                                                      'five_yearly'
                                                                    ? 'TimeBidder Offer Plan - '
                                                                    : null}
                                                            </b>
                                                        </span>
                                                        <span>
                                                            {user.membership_period ===
                                                            'monthly' ? (
                                                                <>
                                                                    {currencyFormat(
                                                                        membership.monthly_deposit_amount,
                                                                    )}
                                                                    /month
                                                                </>
                                                            ) : user.membership_period ===
                                                              'yearly' ? (
                                                                <>
                                                                    {currencyFormat(
                                                                        membership.yearly_deposit_amount,
                                                                    )}
                                                                    /year
                                                                </>
                                                            ) : user.membership_period ===
                                                              'five_yearly' ? (
                                                                <>
                                                                    {currencyFormat(
                                                                        500,
                                                                        // membership.yearly_deposit_amount,
                                                                    )}
                                                                    /five year
                                                                </>
                                                            ) : user.membership_period ===
                                                              'free' ? (
                                                                <>Free Trial</>
                                                            ) : null}
                                                        </span>
                                                        {/* <span>
                                                            {user.membership_period === 'yearly' ? (
                                                                <>
                                                                    {' '}
                                                                    {currencyFormat(
                                                                        membership.yearly_deposit_amount,
                                                                    )}
                                                                    {membership.yearly_period ==
                                                                    '1825'
                                                                        ? '/five Year'
                                                                        : membership.yearly_period ==
                                                                          '30'
                                                                        ? '/month'
                                                                        : '/year'}
                                                                </>
                                                            ) : user.membership_period ===
                                                              'free' ? (
                                                                <>Free Trial</>
                                                            ) : null}
                                                        </span> */}
                                                    </li>
                                                    <li className="divider"></li>
                                                </>
                                            ) : null}

                                            <li>
                                                <span className="planNameWrp">
                                                    <b>
                                                        {`${capitalizeFirstLetter(
                                                            cardFormik.values.planName,
                                                        )} Plan`}
                                                    </b>
                                                </span>
                                                <span>
                                                    {currencyFormat(
                                                        cardFormik.values.amt === 300
                                                            ? 150
                                                            : cardFormik.values.amt,
                                                    )}
                                                </span>
                                            </li>

                                            <li className="divider"></li>
                                            <li>
                                                <span>
                                                    <strong>Total :</strong>
                                                </span>

                                                <span>
                                                    {currencyFormat(
                                                        cardFormik.values.amt === 300
                                                            ? 150
                                                            : cardFormik.values.amt,
                                                    )}
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                    {/* <div className="rtImg">
                                        <img src="/assets/images/crown.png" />
                                    </div> */}
                                </div>
                            </div>
                        ) : null}
                        <div className="d-flex align-items-center justify-content-end mb-4">
                            <SecondaryButton
                                label={
                                    <>
                                        <span className="material-icons">add</span>
                                        Add New Card
                                    </>
                                }
                                onClick={() => {
                                    toggleFullScreenCardPopup(true, 'new', null)
                                }}
                            />
                        </div>
                        {cardFormik.values.planName ? (
                            <>
                                <div className="chCnt chCntGrid">
                                    {cards &&
                                        cards.map((data, index) => (
                                            // eslint-disable-next-line react/jsx-key
                                            <div className="selectAddress  d-flex justify-content-start align-items-center">
                                                <input
                                                    name="cards"
                                                    value={data.id}
                                                    onChange={() => handleSelect(data)}
                                                    type="radio"
                                                    id={`card_${index}`}
                                                    hidden
                                                ></input>
                                                <label htmlFor={`card_${index}`}>
                                                    <ListItem button>
                                                        {data.id === cardFormik.values.cards ? (
                                                            <span className="material-icons">
                                                                radio_button_checked
                                                            </span>
                                                        ) : (
                                                            <span className="material-icons">
                                                                radio_button_unchecked
                                                            </span>
                                                        )}
                                                        <div
                                                            className="savedAddressCard"
                                                            key={index}
                                                        >
                                                            <div>
                                                                <h5>
                                                                    {data.brand} ending in{' '}
                                                                    {data.last4}
                                                                </h5>
                                                                <h5>
                                                                    EXP. {data.exp_month}/
                                                                    {data.exp_year}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </ListItem>
                                                </label>
                                            </div>
                                        ))}
                                </div>

                                <div className="chCnt chCntGrid">
                                    {banks &&
                                        banks.map((data, index) => (
                                            // eslint-disable-next-line react/jsx-key
                                            <div className="selectAddress  d-flex justify-content-start align-items-center">
                                                <input
                                                    name="cards"
                                                    value={data.id}
                                                    onChange={() => handleSelect(data)}
                                                    type="radio"
                                                    id={`bank_${index}`}
                                                    hidden
                                                ></input>
                                                <label htmlFor={`bank_${index}`}>
                                                    <ListItem button>
                                                        {data.id === cardFormik.values.cards ? (
                                                            <span className="material-icons">
                                                                radio_button_checked
                                                            </span>
                                                        ) : (
                                                            <span className="material-icons">
                                                                radio_button_unchecked
                                                            </span>
                                                        )}
                                                        <div
                                                            className="savedAddressCard"
                                                            key={index}
                                                        >
                                                            <div>
                                                                <h5>{data.bank_name}</h5>
                                                                <h5>
                                                                    {data.last4}/
                                                                    {data.routing_number}
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </ListItem>
                                                </label>
                                            </div>
                                        ))}
                                </div>
                                <div className="mt-4  d-flex justify-content-center align-item-center   ">
                                    <PrimaryButton
                                        onClick={() => cardFormik.handleSubmit()}
                                        label="Submit"
                                        type="submit"
                                        className={'pmButton'}
                                        disabled={paymentLoading}
                                    />
                                </div>
                            </>
                        ) : null}
                    </div>
                </div>
                {/* <SkyflowCardDetails data={manageCard} function={toggleFullScreenCardPopup} /> */}
                <MyPaymentComponent
                    allCards={cards}
                    data={manageCard}
                    function={toggleFullScreenCardPopup}
                    from="card"
                />
                <BankDetails data={manageBank} function={toggleFullScreenBankPopup} />
            </FullScreenPopup>
            <MyPaymentComponent
                allCards={cards}
                data={manageCard}
                function={toggleFullScreenCardPopup}
                from="card"
            />
        </>
        // <div className="subsWrapper customContainer">
        //     <div>
        //         <h2 className="subsTitle text-center">Subscription Plans</h2>
        //         <div className="tmSwtBox d-flex align-items-center justify-content-center mt-4">
        //             {/* {user && user.membership_period === 'yearly' ? (
        //                 <></>
        //             ) : (
        //                 <>
        //                     {' '}
        //                     <label
        //                         className={`m-0 mr-2 ${
        //                             cardFormik.values.period === 'monthly' ? 'colorPrimary' : ''
        //                         }`}
        //                     >
        //                         Monthly
        //                     </label>
        //                     <Switch
        //                         checked={cardFormik.values.period === 'yearly' ? true : false}
        //                         onChange={handleChange}
        //                         name="checkedA"
        //                         inputProps={{ 'aria-label': 'secondary checkbox' }}
        //                     />
        //                     <label
        //                         className={`m-0 ml-2 ${
        //                             cardFormik.values.period === 'yearly' ? 'colorPrimary' : ''
        //                         }`}
        //                     >
        //                         Yearly
        //                     </label>{' '}
        //                 </>
        //             )} */}
        //         </div>
        //         <div className="SubsTableWrpr">
        //             <div className="fstColmn colWrpr">
        //                 <div className="tblHdrVw">
        //                     <h3>Features</h3>
        //                 </div>
        //                 {/* <div>Number of bidders/auction</div> */}
        //                 <div>Unlimited number of bids</div>
        //                 {/* <div>Number of auctions/year</div> */}
        //                 <div>Unlimited number of auctions</div>
        //                 <div>Auction templates/cloning</div>
        //                 <div>Pre-bid functionality</div>
        //                 {/* <div>Proxy bidding available</div> */}
        //                 <div>Maximum bidding available</div>
        //                 <div>Duplicate bids allowed</div>
        //                 <div>Mulitple shifts or location grouping</div>
        //                 <div>Sniping prevention with Automated Auction extensions</div>
        //                 <div>Success Manager</div>
        //                 <div>Onboarding*</div>
        //             </div>
        //             {console.log('hiiii', bidPlan)}
        //             {bidPlan &&
        //                 bidPlan.map((data, index) => (
        //                     // eslint-disable-next-line react/jsx-key
        //                     <>
        //                         <div
        //                             className={`plnColmn colWrpr ${
        //                                 data.type == membership?.type ? 'active' : ''
        //                             }`}
        //                         >
        //                             <div className="tblHdrVw">
        //                                 <div className="plnTlDiv d-block text-center">
        //                                     {data.type == membership?.type ? (
        //                                         <p className="activeTag">Active</p>
        //                                     ) : data.type == '5 for 5' ? (
        //                                         <p className="activeTag">Limited-time Offer</p>
        //                                     ) : (
        //                                         ''
        //                                     )}

        //                                     <h2>{data.type}</h2>
        //                                     {data.type === 'enterprise' ? (
        //                                         <Link className="cntLnk" to="/contactus">
        //                                             Contact Us
        //                                         </Link>
        //                                     ) : (
        //                                         <>
        //                                             {cardFormik.values.period === 'yearly' ? (
        //                                                 <h3>
        //                                                     {currencyFormat(
        //                                                         data.yearly_deposit_amount === 300
        //                                                             ? 150
        //                                                             : data.yearly_deposit_amount,
        //                                                     )}
        //                                                     /year
        //                                                 </h3>
        //                                             ) : (
        //                                                 <h3>
        //                                                     {currencyFormat(
        //                                                         data.monthly_deposit_amount,
        //                                                     )}
        //                                                     /month
        //                                                 </h3>
        //                                             )}
        //                                             {user && user.trial_count < 1 ? (
        //                                                 <> {submitButton('freetrial', data)} </>
        //                                             ) : null}
        //                                         </>
        //                                     )}
        //                                 </div>
        //                             </div>
        //                             <div>
        //                                 {data.type === 'enterprise' ? (
        //                                     'Unlimited'
        //                                 ) : (
        //                                     <>
        //                                         {data.users_limit_from}-{data.users_limit_to}
        //                                     </>
        //                                 )}
        //                             </div>
        //                             <div>
        //                                 {data.type === 'enterprise'
        //                                     ? 'Unlimited'
        //                                     : data.auctions_year}
        //                             </div>
        //                             {/* <div>{data.additonal_auction ? data.additonal_auction : 'N/A'}</div> */}
        //                             <div>
        //                                 {data.auction_template ? (
        //                                     <span className="material-icons-outlined avlBtn">
        //                                         check_circle
        //                                     </span>
        //                                 ) : (
        //                                     <span className="material-icons-outlined ntAvlBtn">
        //                                         highlight_off
        //                                     </span>
        //                                 )}
        //                             </div>
        //                             <div>
        //                                 {data.pre_bid ? (
        //                                     <span className="material-icons-outlined avlBtn">
        //                                         check_circle
        //                                     </span>
        //                                 ) : (
        //                                     <span className="material-icons-outlined ntAvlBtn">
        //                                         highlight_off
        //                                     </span>
        //                                 )}
        //                             </div>
        //                             <div>
        //                                 {/* {data.proxy_bid ? ( */}
        //                                 <span className="material-icons-outlined avlBtn">
        //                                     check_circle
        //                                 </span>
        //                                 {/* ) : (
        //                                 <span className="material-icons-outlined ntAvlBtn">
        //                                     highlight_off
        //                                 </span>
        //                             )} */}
        //                             </div>
        //                             <div>
        //                                 {data.duplicate_bid ? (
        //                                     <span className="material-icons-outlined avlBtn">
        //                                         check_circle
        //                                     </span>
        //                                 ) : (
        //                                     <span className="material-icons-outlined ntAvlBtn">
        //                                         highlight_off
        //                                     </span>
        //                                 )}
        //                             </div>

        //                             <div>
        //                                 {data.multishift ? (
        //                                     <span className="material-icons-outlined avlBtn">
        //                                         check_circle
        //                                     </span>
        //                                 ) : (
        //                                     <span className="material-icons-outlined ntAvlBtn">
        //                                         highlight_off
        //                                     </span>
        //                                 )}
        //                             </div>
        //                             <div>
        //                                 {data.extend_auction ? (
        //                                     <span className="material-icons-outlined avlBtn">
        //                                         check_circle
        //                                     </span>
        //                                 ) : (
        //                                     <span className="material-icons-outlined ntAvlBtn">
        //                                         highlight_off
        //                                     </span>
        //                                 )}
        //                             </div>
        //                             <div>
        //                                 {data.success_manager ? (
        //                                     <span className="material-icons-outlined avlBtn">
        //                                         check_circle
        //                                     </span>
        //                                 ) : (
        //                                     <span className="material-icons-outlined ntAvlBtn">
        //                                         highlight_off
        //                                     </span>
        //                                 )}
        //                             </div>
        //                             <div>
        //                                 {data?.type === 'gold'
        //                                     ? '1 session included'
        //                                     : data?.type === 'enterprise'
        //                                     ? 'Included'
        //                                     : ''}
        //                             </div>
        //                             {/* <div>
        //                             {data?.type === 'gold'
        //                                 ? '1 session included'
        //                                 : data?.type === 'enterprise'
        //                                 ? 'Included'
        //                                 : '$395.00/session'}
        //                         </div> */}
        //                             {membership ? (
        //                                 <>
        //                                     {user.membership_period === 'monthly' ? (
        //                                         <>
        //                                             {cardFormik.values.period === 'monthly' ? (
        //                                                 <>
        //                                                     {membership.type === 'bronze' ? (
        //                                                         <>
        //                                                             {data.type === 'bronze' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'active',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type === 'silver' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'upgrade',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type === 'gold' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'upgrade',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type ===
        //                                                               'enterprise' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'contact',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : null}
        //                                                         </>
        //                                                     ) : membership.type === 'silver' ? (
        //                                                         <>
        //                                                             {data.type === 'bronze' ? (
        //                                                                 <></>
        //                                                             ) : data.type === 'silver' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'active',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type === 'gold' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'upgrade',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type ===
        //                                                               'enterprise' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'contact',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : null}
        //                                                         </>
        //                                                     ) : membership.type === 'gold' ? (
        //                                                         <>
        //                                                             {data.type === 'bronze' ? (
        //                                                                 <></>
        //                                                             ) : data.type === 'silver' ? (
        //                                                                 <></>
        //                                                             ) : data.type === 'gold' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'active',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type ===
        //                                                               'enterprise' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'contact',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : null}
        //                                                         </>
        //                                                     ) : membership.type === 'enterprise' ? (
        //                                                         <>
        //                                                             {data.type === 'bronze' ? (
        //                                                                 <></>
        //                                                             ) : data.type === 'silver' ? (
        //                                                                 <></>
        //                                                             ) : data.type === 'gold' ? (
        //                                                                 <></>
        //                                                             ) : data.type ===
        //                                                               'enterprise' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'active',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : null}
        //                                                         </>
        //                                                     ) : (
        //                                                         <>{submitButton('started', data)}</>
        //                                                     )}
        //                                                 </>
        //                                             ) : cardFormik.values.period === 'yearly' ? (
        //                                                 <>
        //                                                     {' '}
        //                                                     {membership.type === 'bronze' ? (
        //                                                         <>
        //                                                             {data.type === 'bronze' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'started',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type === 'silver' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'started',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type === 'gold' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'started',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type ===
        //                                                               'enterprise' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'contact',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : null}
        //                                                         </>
        //                                                     ) : membership.type === 'silver' ? (
        //                                                         <>
        //                                                             {data.type === 'bronze' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'started',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type === 'silver' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'started',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type === 'gold' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'started',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type ===
        //                                                               'enterprise' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'contact',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : null}
        //                                                         </>
        //                                                     ) : membership.type === 'gold' ? (
        //                                                         <>
        //                                                             {data.type === 'bronze' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'started',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type === 'silver' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'started',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type === 'gold' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'started',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type ===
        //                                                               'enterprise' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'contact',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : null}
        //                                                         </>
        //                                                     ) : membership.type === 'enterprise' ? (
        //                                                         <>
        //                                                             {data.type === 'bronze' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'started',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type === 'silver' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'started',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type === 'gold' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'started',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type ===
        //                                                               'enterprise' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'contact',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : null}
        //                                                         </>
        //                                                     ) : (
        //                                                         <>{submitButton('started', data)}</>
        //                                                     )}{' '}
        //                                                 </>
        //                                             ) : null}
        //                                         </>
        //                                     ) : user.membership_period === 'yearly' ? (
        //                                         <>
        //                                             {cardFormik.values.period === 'yearly' &&
        //                                             !user.membership_date ? (
        //                                                 <>
        //                                                     {membership.type === 'bronze' ? (
        //                                                         <>
        //                                                             {data.type === 'bronze' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'active',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type === 'silver' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'upgrade',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type === 'gold' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'upgrade',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type ===
        //                                                               'enterprise' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'contact',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : null}
        //                                                         </>
        //                                                     ) : membership.type === 'silver' ? (
        //                                                         <>
        //                                                             {data.type === 'bronze' ? (
        //                                                                 <></>
        //                                                             ) : data.type === 'silver' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'active',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type === 'gold' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'upgrade',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type ===
        //                                                               'enterprise' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'contact',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : null}
        //                                                         </>
        //                                                     ) : membership.type === 'gold' ? (
        //                                                         <>
        //                                                             {data.type === 'bronze' ? (
        //                                                                 <></>
        //                                                             ) : data.type === 'silver' ? (
        //                                                                 <></>
        //                                                             ) : data.type === 'gold' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'active',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : data.type ===
        //                                                               'enterprise' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'contact',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : null}
        //                                                         </>
        //                                                     ) : membership.type === 'enterprise' ? (
        //                                                         <>
        //                                                             {data.type === 'bronze' ? (
        //                                                                 <></>
        //                                                             ) : data.type === 'silver' ? (
        //                                                                 <></>
        //                                                             ) : data.type === 'gold' ? (
        //                                                                 <></>
        //                                                             ) : data.type ===
        //                                                               'enterprise' ? (
        //                                                                 <>
        //                                                                     {submitButton(
        //                                                                         'active',
        //                                                                         data,
        //                                                                     )}
        //                                                                 </>
        //                                                             ) : null}
        //                                                         </>
        //                                                     ) : (
        //                                                         <>{submitButton('started', data)}</>
        //                                                     )}
        //                                                 </>
        //                                             ) : cardFormik.values.period === 'monthly' ? (
        //                                                 <> </>
        //                                             ) : null}
        //                                         </>
        //                                     ) : user.membership_period === 'free' ? (
        //                                         <>
        //                                             {cardFormik.values.period === 'yearly' ? (
        //                                                 <>
        //                                                     {membership.type === data.type ? (
        //                                                         <>
        //                                                             {submitButton(
        //                                                                 'active_started',
        //                                                                 data,
        //                                                             )}
        //                                                         </>
        //                                                     ) : data.type === 'enterprise' ? (
        //                                                         <>{submitButton('contact', data)}</>
        //                                                     ) : (
        //                                                         <>{submitButton('started', data)}</>
        //                                                     )}
        //                                                 </>
        //                                             ) : cardFormik.values.period === 'monthly' ? (
        //                                                 <>
        //                                                     {membership.type === data.type ? (
        //                                                         <>
        //                                                             {submitButton(
        //                                                                 'active_started',
        //                                                                 data,
        //                                                             )}
        //                                                         </>
        //                                                     ) : data.type === 'enterprise' ? (
        //                                                         <>{submitButton('contact', data)}</>
        //                                                     ) : (
        //                                                         <>{submitButton('started', data)}</>
        //                                                     )}
        //                                                 </>
        //                                             ) : null}
        //                                         </>
        //                                     ) : null}
        //                                 </>
        //                             ) : (
        //                                 <>{submitButton('started', data)}</>
        //                             )}
        //                         </div>
        //                     </>
        //                 ))}
        //         </div>
        //         <p className="text-left onbrdInfo">
        //             *Onboarding is one 45-60 minute training demo via zoom meeting.{' '}
        //         </p>

        //         <FullScreenPopup
        //             className={'adTempltPopup subPayPopup'}
        //             modaltitle={'Free Trial Confirmation'}
        //             open={freeTrialPopup}
        //             handleClose={() => setFreeTrialPopup(false)}
        //         >
        //             <div className="addUserModal mt-4">
        //                 {freeTrialFormik.values.planName ? (
        //                     <div className={`orderReviewBox ${freeTrialFormik.values.planName}`}>
        //                         <div className="d-flex align-items-center justify-content-between">
        //                             <div className="lftRvwBox">
        //                                 <h5>Order Review</h5>
        //                                 <ul className="orderListli">
        //                                     <li>
        //                                         <span className="planNameWrp">
        //                                             <b>
        //                                                 {`${capitalizeFirstLetter(
        //                                                     freeTrialFormik.values.planName,
        //                                                 )} Plan - Free Trial`}
        //                                             </b>
        //                                         </span>
        //                                     </li>
        //                                 </ul>
        //                             </div>
        //                             <div className="rtImg">
        //                                 <img src="/assets/images/crown.png" />
        //                             </div>
        //                         </div>
        //                     </div>
        //                 ) : null}
        //                 {freeTrialFormik.values.planName ? (
        //                     <>
        //                         <div className="mt-4">
        //                             <PrimaryButton
        //                                 onClick={() => freeTrialFormik.handleSubmit()}
        //                                 label="Submit"
        //                                 type="submit"
        //                                 disabled={paymentLoading}
        //                             />
        //                         </div>
        //                     </>
        //                 ) : null}
        //             </div>
        //         </FullScreenPopup>

        //         <FullScreenPopup
        //             className={'adTempltPopup subPayPopup'}
        //             modaltitle={'Subscription Payment'}
        //             open={subPayPopup}
        //             handleClose={() => setSubPayPopup(false)}
        //         >
        //             <div className="customContainer">
        //                 <div className="addUserModal mt-4">
        //                     {cardFormik.values.planName ? (
        //                         <div className={`orderReviewBox ${cardFormik.values.planName}`}>
        //                             <div className="d-flex align-items-center justify-content-between subCstmWrpCls">
        //                                 <div className="lftRvwBox">
        //                                     <h5>Order Review</h5>
        //                                     <ul className="orderListli">
        //                                         {membership ? (
        //                                             <>
        //                                                 <li>
        //                                                     <span>
        //                                                         <b>
        //                                                             Existing Plan :{' '}
        //                                                             {capitalize(membership.type)}{' '}
        //                                                             Plan
        //                                                         </b>
        //                                                     </span>
        //                                                     <span>
        //                                                         {user.membership_period ===
        //                                                         'monthly' ? (
        //                                                             <>
        //                                                                 {currencyFormat(
        //                                                                     membership.monthly_deposit_amount,
        //                                                                 )}
        //                                                                 /month
        //                                                             </>
        //                                                         ) : user.membership_period ===
        //                                                           'yearly' ? (
        //                                                             <>
        //                                                                 {currencyFormat(
        //                                                                     membership.yearly_deposit_amount,
        //                                                                 )}
        //                                                                 /year
        //                                                             </>
        //                                                         ) : user.membership_period ===
        //                                                           'free' ? (
        //                                                             <>Free Trial</>
        //                                                         ) : null}
        //                                                     </span>
        //                                                 </li>
        //                                                 <li className="divider"></li>
        //                                             </>
        //                                         ) : null}

        //                                         <li>
        //                                             <span className="planNameWrp">
        //                                                 <b>
        //                                                     {`${capitalizeFirstLetter(
        //                                                         cardFormik.values.planName,
        //                                                     )} Plan`}
        //                                                 </b>
        //                                             </span>
        //                                             <span>
        //                                                 {currencyFormat(
        //                                                     cardFormik.values.amt === 300
        //                                                         ? 150
        //                                                         : cardFormik.values.amt,
        //                                                 )}
        //                                             </span>
        //                                         </li>

        //                                         <li className="divider"></li>
        //                                         <li>
        //                                             <span>
        //                                                 <strong>Total :</strong>
        //                                             </span>
        //                                             {/* {membership ? (
        //                                             <span>
        //                                                 {user.membership_period === 'monthly' ? (
        //                                                     <>
        //                                                         {currencyFormat(
        //                                                             cardFormik.values.amt -
        //                                                                 membership.monthly_deposit_amount,
        //                                                         )}
        //                                                     </>
        //                                                 ) : (
        //                                                     <>
        //                                                         {currencyFormat(
        //                                                             cardFormik.values.amt -
        //                                                                 membership.yearly_deposit_amount,
        //                                                         )}
        //                                                     </>
        //                                                 )}
        //                                             </span>
        //                                         ) : (
        //                                             <span>
        //                                                 {currencyFormat(cardFormik.values.amt)}
        //                                             </span>
        //                                         )} */}

        //                                             <span>
        //                                                 {currencyFormat(
        //                                                     cardFormik.values.amt === 300
        //                                                         ? 150
        //                                                         : cardFormik.values.amt,
        //                                                 )}
        //                                             </span>
        //                                         </li>
        //                                     </ul>
        //                                 </div>
        //                                 <div className="rtImg">
        //                                     <img src="/assets/images/crown.png" />
        //                                 </div>
        //                             </div>
        //                         </div>
        //                     ) : null}
        //                     <div className="d-flex align-items-center justify-content-end mb-4">
        //                         <SecondaryButton
        //                             label={
        //                                 <>
        //                                     <span className="material-icons">add</span>
        //                                     Add New Card
        //                                 </>
        //                             }
        //                             onClick={() => {
        //                                 toggleFullScreenCardPopup(true, 'new', null)
        //                             }}
        //                         />
        //                         {/* <SecondaryButton
        //                             btnSize="ml-2"
        //                             label={
        //                                 <>
        //                                     <span className="material-icons">add</span>
        //                                     Add New Bank
        //                                 </>
        //                             }
        //                             onClick={() => {
        //                                 toggleFullScreenBankPopup(true, 'new', null)
        //                             }}
        //                         /> */}
        //                     </div>
        //                     {cardFormik.values.planName ? (
        //                         <>
        //                             <div className="chCnt chCntGrid">
        //                                 {cards &&
        //                                     cards.map((data, index) => (
        //                                         // eslint-disable-next-line react/jsx-key
        //                                         <div className="selectAddress  d-flex justify-content-start align-items-center">
        //                                             <input
        //                                                 name="cards"
        //                                                 value={data.id}
        //                                                 onChange={() => handleSelect(data)}
        //                                                 type="radio"
        //                                                 id={`card_${index}`}
        //                                                 hidden
        //                                             ></input>
        //                                             <label htmlFor={`card_${index}`}>
        //                                                 <ListItem button>
        //                                                     {data.id === cardFormik.values.cards ? (
        //                                                         <span className="material-icons">
        //                                                             radio_button_checked
        //                                                         </span>
        //                                                     ) : (
        //                                                         <span className="material-icons">
        //                                                             radio_button_unchecked
        //                                                         </span>
        //                                                     )}
        //                                                     <div
        //                                                         className="savedAddressCard"
        //                                                         key={index}
        //                                                     >
        //                                                         <div>
        //                                                             <h5>
        //                                                                 {data.brand} ending in{' '}
        //                                                                 {data.last4}
        //                                                             </h5>
        //                                                             <h5>
        //                                                                 EXP. {data.exp_month}/
        //                                                                 {data.exp_year}
        //                                                             </h5>
        //                                                         </div>
        //                                                     </div>
        //                                                 </ListItem>
        //                                             </label>
        //                                         </div>
        //                                     ))}
        //                             </div>

        //                             <div className="chCnt chCntGrid">
        //                                 {banks &&
        //                                     banks.map((data, index) => (
        //                                         // eslint-disable-next-line react/jsx-key
        //                                         <div className="selectAddress  d-flex justify-content-start align-items-center">
        //                                             <input
        //                                                 name="cards"
        //                                                 value={data.id}
        //                                                 onChange={() => handleSelect(data)}
        //                                                 type="radio"
        //                                                 id={`bank_${index}`}
        //                                                 hidden
        //                                             ></input>
        //                                             <label htmlFor={`bank_${index}`}>
        //                                                 <ListItem button>
        //                                                     {data.id === cardFormik.values.cards ? (
        //                                                         <span className="material-icons">
        //                                                             radio_button_checked
        //                                                         </span>
        //                                                     ) : (
        //                                                         <span className="material-icons">
        //                                                             radio_button_unchecked
        //                                                         </span>
        //                                                     )}
        //                                                     <div
        //                                                         className="savedAddressCard"
        //                                                         key={index}
        //                                                     >
        //                                                         <div>
        //                                                             <h5>{data.bank_name}</h5>
        //                                                             <h5>
        //                                                                 {data.last4}/
        //                                                                 {data.routing_number}
        //                                                             </h5>
        //                                                         </div>
        //                                                     </div>
        //                                                 </ListItem>
        //                                             </label>
        //                                         </div>
        //                                     ))}
        //                             </div>
        //                             <div className="mt-4  d-flex justify-content-center align-item-center   ">
        //                                 <PrimaryButton
        //                                     onClick={() => cardFormik.handleSubmit()}
        //                                     label="Submit"
        //                                     type="submit"
        //                                     className={'pmButton'}
        //                                     disabled={paymentLoading}
        //                                 />
        //                             </div>
        //                             {/* <form onSubmit={cardFormik.handleSubmit}>
        //                             {cardFormik.values.membership !== 'free' ? (
        //                                 <>
        //                                     <h5 className="paymentMethods mb-4">Pay with card</h5>
        //                                     <CardDetails
        //                                         data={manageCard}
        //                                         function={toggleFullScreenCardPopup}
        //                                         // data={{
        //                                         //     popup: false,
        //                                         //     status: 'new',
        //                                         //     data: null,
        //                                         // }}
        //                                     />

        //                                     <div className="paymentform">
        //                                         <div className="row">{mapData(cardDetails)}</div>
        //                                     </div>
        //                                 </>
        //                             ) : (
        //                                 ''
        //                             )}
        //                             <div className="registerviw">
        //                                 <PrimaryButton
        //                                     label="Submit"
        //                                     type="submit"
        //                                     disabled={paymentLoading}
        //                                 />
        //                                 {paymentLoading ? (
        //                                     <CircularProgress
        //                                         size={24}
        //                                         className={classes.buttonProgress}
        //                                     />
        //                                 ) : null}
        //                             </div>
        //                         </form> */}
        //                         </>
        //                     ) : null}
        //                 </div>
        //             </div>
        //             {/* <SkyflowCardDetails data={manageCard} function={toggleFullScreenCardPopup} /> */}
        //             <MyPaymentComponent
        //                 allCards={cards}
        //                 data={manageCard}
        //                 function={toggleFullScreenCardPopup}
        //                 from="card"
        //             />
        //             <BankDetails data={manageBank} function={toggleFullScreenBankPopup} />
        //         </FullScreenPopup>
        //     </div>
        // </div>
    )
}
